import { Controller } from "@hotwired/stimulus";

// Mirrors the onboarding form into a sample invoice so people see what they
// are building: business name, example services for their trade, and a total
// in their currency.
export default class extends Controller {
	static targets = [
		"nameInput",
		"tradeInput",
		"currencyInput",
		"name",
		"lines",
		"total",
	];
	static values = { trades: Object, placeholder: String };

	connect() {
		this.render();
	}

	update() {
		this.render();
	}

	render() {
		const currency = this.currencyInputTarget.value || "USD";
		const items = this.tradesValue[this.tradeInputTarget.value] || [];
		const money = new Intl.NumberFormat("en", { style: "currency", currency });

		this.nameTarget.textContent =
			this.nameInputTarget.value.trim() || this.placeholderValue;
		this.nameTarget.classList.toggle(
			"text-ink-400",
			!this.nameInputTarget.value.trim(),
		);

		this.linesTarget.replaceChildren(
			...items.map((item) => this.line(item, money)),
		);

		const total = items.reduce(
			(sum, item) => sum + item.quantity * item.unit_price,
			0,
		);
		this.totalTarget.textContent = money.format(total);
	}

	line(item, money) {
		const row = document.createElement("li");
		row.className = "flex items-baseline justify-between gap-4 py-2";

		const label = document.createElement("span");
		label.className = "text-sm text-ink-700";
		label.textContent =
			item.quantity > 1 ? `${item.name} × ${item.quantity}` : item.name;

		const amount = document.createElement("span");
		amount.className = "money text-sm text-primary-900";
		amount.textContent = money.format(item.quantity * item.unit_price);

		row.append(label, amount);
		return row;
	}
}
